export default __webpack_public_path__ + "static/benifitImage-88938df5d19fd8f78240a914d175f258.png";